export default "__VITE_ASSET__DOBp8hk6__"